import React from "react";

//Importar íconos de Material UI.
import { FileUpload } from '@mui/icons-material/';

// DraggingView: Componente que se renderiza al arrastar un archivo multimedia en el chat,
// muestra el ícono de subir un archivo y el texto de "subir".

const Draggingview = () => {

    return (
        <div className= "container-file__upload">

            {/*--------Icono de subir archivo------------- */}
            <FileUpload sx={{fontSize: "80px", color: "var(--bg-ligth)"}} />

            {/*------------Texto de soltar el archivo------------ */}
            <span>Subir los archivos aquí</span>

        </div>
    )

};

export default Draggingview;